module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"details":"Details","save":"Speichern","empties":"Leergut"},"en":{"details":"Details","save":"Save","empties":"Empties"}}')
  delete Component.options._Ctor
}
